import React from "react";
import CommonNavbar from "../components/CommonNavbar/CommonNavbar";
import CommonFooter from "../components/CommonFooter/CommonFooter";
import BlogDetails from "../components/BlogDetails/BlogDetails";

const BlogDetailsPage = () => {
  return (
    <div>
      <CommonNavbar hide_btn="d-none" show_btn="d-block" />
      <BlogDetails />
      <CommonFooter />
    </div>
  );
};

export default BlogDetailsPage;
